module.exports = __webpack_public_path__ + "static/media/1.c680af7e.jpg";